export enum PopupHeaderState {
  Default,
  Filter,
  EntitiesSelected
}
